
import { defineComponent } from 'vue';
import { ErrorMessage } from 'vee-validate';

export default defineComponent({
    name: 'InputErrorMessage',
    components: { ErrorMessage },
    props: {
        name: {
            type: String,
            default: '',
        },
    },
});
